var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoftwareDevelopment14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "93px",
    height: "93px",
    viewBox: "0 0 93 93",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Media Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 181023,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Software-Development-V1",
    transform: "translate(-465.000000, -7277.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Industries-We-Serve",
    transform: "translate(326.000000, 6306.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 7,
    transform: "translate(1.000000, 931.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Media-Icon",
    transform: "translate(138.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-4",
    fill: "#DDFCF5",
    opacity: 0.300000012,
    cx: 46.1999951,
    cy: 46.1999951,
    r: 46.1999951
  }), /*#__PURE__*/React.createElement("g", {
    id: "media",
    transform: "translate(26.899990, 31.699995)",
    stroke: "#00E6B2",
    strokeWidth: 1.57499993
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.5662156,
    y: 0.193593703,
    width: 36.6675636,
    height: 23.7747751
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.02195353,
    y1: 27.9781443,
    x2: 29.7780412,
    y2: 27.9781443,
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "23.8284334 12.0809813 18.8999974 14.9276458 13.9715614 17.7703677 13.9715614 12.0809813 13.9715614 6.38765201 18.8999974 9.23431666"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwareDevelopment14);
export default __webpack_public_path__ + "static/media/software-development14.b3f872526d4b9931fb0ca48bee375cba.svg";
export { ForwardRef as ReactComponent };